<iframe #previewiframe [class]="cssClass"></iframe>
